<template>
  <div>
    <ModalVideoBiliBili
      v-if="showModal"
      :id="showModalId"
      @close="closeModal"
    />
    <Banner :with-bias-banner="true" />
    <section class="hero hero-desktop">
      <div class="image">
        <h1 class="m-0 p-0">
          BIAS FX
          <span>移动版</span>
        </h1>
        <p class="subtitle m-0 p-0">
          完整的 iOS 吉他音箱和效果器
        </p>
        <p class="mobile-en mt-3 text-center font-bold">
          <a
            class="underline"
            target="_blank"
            href="https://www.positivegrid.com/bias-fx-mobile"
          >BIAS FX 2 英文移动版</a>已正式上线！<br>
          中文版即将推出，敬请期待！
        </p>
        <a
          class="app-download"
          href="https://apps.apple.com/cn/app/bias-fx-2-1-guitar-tone-app/id1475438828"
        />
      </div>
      <BiasBanner />
    </section>
    <section class="hero hero-mobile">
      <div class="image" />
      <h1>
        BIAS FX
        <span>移动版</span>
      </h1>
      <p class="subtitle">
        完整的 iOS 吉他音箱和效果器
      </p>
      <p class="mobile-en mt-3 text-center font-bold">
        <a
          class="underline"
          target="_blank"
          href="https://www.positivegrid.com/bias-fx-mobile"
        >BIAS FX 2 英文移动版</a>已正式上线！<br>
        中文版即将推出，敬请期待！
      </p>
      <a href="https://itunes.apple.com/us/app/bias-fx-guitar-amp-effects/id937685528" />
      <BiasBanner />
    </section>
    <section class="feature">
      <div
        id="feature-card-1"
        class="feature-card"
      >
        <p>Positive Grid 提供数百种令人惊叹的音箱和效果</p>
      </div>
      <div
        id="feature-card-2"
        class="feature-card"
      >
        <p>Live View 现场演出模式将手机/平板电脑随时变成一个吉他音色处理器</p>
      </div>
      <div
        id="feature-card-3"
        class="feature-card"
      >
        <p>在 BIAS FX 里一键无缝开启 BIAS AMP 2</p>
      </div>
      <div
        id="feature-card-4"
        class="feature-card"
      >
        <p>从 ToneCloud 云端下载与分享上千个音色</p>
      </div>
    </section>
    <section class="intro-video">
      <VideoCard
        :image="'video-10.jpg'"
        @playVideo="openModal('47670703')"
      />
    </section>
    <section class="processor">
      <div class="background-banner background-banner-right">
        <div class="text">
          <h3>世界级的吉他效果处理器</h3>
          <p>BIAS FX 能将你的 iOS 设备变成世界级的音箱和效果器。通俗易懂的 BIAS FX 拖放界面能快速给予你无限可能的声音组合。BIAS FX Mobile 提供一系列超拟真的精品音箱，录音棚专业级的机架式处理器和经典吉他效果器。</p>
        </div>
      </div>
    </section>
    <section class="ecosystem">
      <div>
        <div>
          <h3>强大的 BIAS 生态系统</h3>
          <p>BIAS 的先进吉他硬件和软件系列是基于业界最高级的音箱和效果器引擎制作的。BIAS FX 移动版可与 BIAS AMP 2 和 BIAS Pedal 应用无缝连结，实现吉他音箱和效果器的无限定制。</p>
          <p>采用惊人的 AmpMatch™技术，BIAS AMP 2 可让你轻松模拟任何吉他音箱的音色。你还可以透过 BIAS AMP 2 软件来调整心目中的音色 - 从更换真空管，定制前极，后极，输出变压器，整流器，一直到麦克风选择及架设和开式或密闭式的单体箱选择。你可以一键在 BIAS FX 里无缝开启任何 BIAS AMP 音箱，随身携带您最喜爱的吉他设置！</p>
        </div>
        <img src="@/assets/bias-fx-mobile/3-ecosystem-2@2x.png">
      </div>
    </section>
    <section class="tone">
      <div class="background-banner background-banner-right">
        <div class="text">
          <h3>最前沿的音箱音色</h3>
          <p>秉承精益求精的理念，BIAS FX 采用了我们最精湛的超拟真 BIAS AMP 2 音色引擎。这是一种完全不同的音色创作方法。我们与世界知名音乐家，工程师和录音室合作，确保我们的音箱电路具有令人惊叹的真实性和卓越性能。</p>
        </div>
      </div>
    </section>
    <section class="effect">
      <div class="background-banner background-banner-left">
        <div class="text">
          <h3>令人惊叹的效果器</h3>
          <p>BIAS FX 提供多功能又高质量的效果器，从复古效果器踏板模拟到高端的机架式效果器。混合，匹配和调整，带你进入新的音色领域并创造前所未有的声音。BIAS FX 实物般逼真的效果器都是透过拖放界面配合使用，就像模拟录音棚装备一样，可以快速调整到你要的音色。</p>
        </div>
      </div>
    </section>
    <section class="tonecloud">
      <div class="background-banner background-banner-right">
        <div class="text">
          <h3>TONECLOUD™</h3>
          <p>从云端下载效果器板！在 Positive Grid 的云端音色分享平台 ToneCloud 上目前已经有上千个效果器板的分享，而这个数量还在持续不断的增长中。Positive Grid 目前已经正在与许多职业乐手，制作人及录音工程师合作来创造更丰富更庞大的音色平台。浏览试用与下载音色都只需要动几下指头的时间。</p>
        </div>
      </div>
    </section>
    <section
      id="video"
      class="video"
    >
      <h3 style="text-align: center;">
        相关视频
      </h3>
      <div>
        <VideoCard
          :image="'video-1.jpg'"
          @playVideo="openModal('47275057')"
        />
        <VideoCard
          :image="'video-2.jpg'"
          @playVideo="openModal('47276081')"
        />
        <VideoCard
          :image="'video-3.jpg'"
          @playVideo="openModal('47276741')"
        />
        <VideoCard
          :image="'video-4.jpg'"
          @playVideo="openModal('47274889')"
        />
        <VideoCard
          :image="'video-5.jpg'"
          @playVideo="openModal('47274978')"
        />
        <VideoCard
          :image="'video-6.jpg'"
          @playVideo="openModal('47398519')"
        />
        <VideoCard
          :image="'video-7.jpg'"
          @playVideo="openModal('47401800')"
        />
        <VideoCard
          :image="'video-8.jpg'"
          @playVideo="openModal('47398862')"
        />
        <VideoCard
          :image="'video-9.jpg'"
          @playVideo="openModal('47402317')"
        />
        <VideoCard
          :image="'video-11.jpg'"
          @playVideo="openModal('47672393')"
        />
      </div>
    </section>
    <section class="important-feature">
      <div>
        <h3>重要功能</h3>
        <ul>
          <li>非常直觉的操作模式。</li>
          <li>无可比拟，细部模拟到接近模拟的声音质量。</li>
          <li>内建 20 个 BIAS 音箱，并且能从 BIAS AMP 2 软件输入任何音箱型号。</li>
          <li>81 个高质量且全新设计的地板型效果器。</li>
          <li>5 个超高质量的机架式效果器，完美仿真经典音色。</li>
          <li>74 组预置音色，可以迅速找到属于你的音色。</li>
          <li>BIAS AMP 2 联动整合，可以提供前所未有的自定音箱功能与设计。</li>
          <li>双声音通道和同时使用两个音箱的处理技术。</li>
          <li>全新的讯号分离器技术，可以分别处理不同频道的讯号，并且导入可藉由音量大小或频率分配频道的全新技术。</li>
        </ul>
        <ul>
          <li>全新的现场演出模式，你可以使用单颗按钮快速切换音色，使用体验和单块效果器一样简单直觉。</li>
          <li>效果器板模式让你能在一个画面中同时调整所有的效果器与音箱。</li>
          <li>输出模式选择让你在现场演出或录音时能有够更多更方便的选择，可以任意选择输出到音箱后级或者直接输出到舞台调音台，并且提供一个四轨均衡器让你可以在声音讯号的最后一段进行细部的调节。</li>
          <li>完整 MIDI 兼容。</li>
          <li>Inter-App Audio 功能让你能够任意搭配其他声音处理软件，给创作带来无限可能。</li>
        </ul>
      </div>
    </section>
    <section class="footer-link">
      <div>
        <img src="@/assets/bias-fx-mobile/biasfx-icon@2x.png">
      </div>
      <div>
        <h3>
          BIAS FX
          <span>移动版</span>
        </h3>
        <p>完整的 iOS 吉他音箱和效果器</p>
      </div>
    </section>
    <section class="footer-link">
      <a href="https://itunes.apple.com/us/app/bias-fx-guitar-amp-effects/id937685528" />
    </section>
    <footer-weixin />
    <footer-common />
  </div>
</template>

<script>
import BiasBanner from '@/components/bias-banner'
import Banner from '@/components/banner'
import VideoCard from '@/components/video-card'

import ModalVideoBiliBili from '@/components/modal-video-bilibili'

import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'

import SoftwareImageLite from '@/assets/fx-software/image-lite@2x.png'
import SoftwareImageStandard from '@/assets/fx-software/image-standard@2x.png'
import SoftwareImagePro from '@/assets/fx-software/image-pro@2x.png'

import ExpansionImageAcoustic from '@/assets/expansion/image-acoustic-pack@2x.png'
import ExpansionImageBass from '@/assets/expansion/image-bass-pack@2x.png'
import ExpansionImageMetal from '@/assets/expansion/image-metal-pack@2x.png'
import jwtDecode from 'jwt-decode'

import store from '@/store'

export default {
  name: 'Index',
  store,
  components: {
    Banner,
    VideoCard,
    ModalVideoBiliBili,
    FooterWeixin,
    FooterCommon,
    BiasBanner
  },
  data () {
    return {
      showModal: false,
      showModalId: null,
      SoftwareImageLite,
      SoftwareImageStandard,
      SoftwareImagePro,
      ExpansionImageAcoustic,
      ExpansionImageBass,
      ExpansionImageMetal
    }
  },
  computed: {},
  mounted: function () {
    const pgToken = this.hasLoginToken()
    if (pgToken) {
      this.setLoginToken(pgToken)
      const email = jwtDecode(pgToken)['email']
      this.setLoginEmail(email)
    }
  },
  methods: {
    openModal (url) {
      this.showModal = true
      this.showModalId = url
    },
    closeModal () {
      this.showModal = false
    },
    hasLoginToken () {
      let qs = window.location.toString().split('?')[1]
      qs = new window.URLSearchParams('?' + qs)
      return qs.get('pg_token')
    },
    setLoginToken (token) {
      window.localStorage.setItem('PG_TOKEN', token)
    },
    setLoginEmail (email) {
      window.localStorage.setItem('PG_EMAIL', email)
    }
  }
}
</script>

<style lang="scss" scoped>
.background-banner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 680px;
  background-size: cover;
}
.background-banner-left .text {
  padding-left: 60%;
  padding-right: 15%;
}
.background-banner-right .text {
  padding-left: 15%;
  padding-right: 60%;
}

.background-banner .text,
.important-feature li {
  line-height: 1.93;
}

section h3 {
  color: #e8e8e8;
  font-size: 30px;
  font-weight: 600;
}
section p {
  color: #c3c3c3;
  font-size: 15px;
  line-height: 29px;
}
section.ecosystem {
  background-image: linear-gradient(to bottom, black, #1d140d);
}
section.ecosystem div > div {
  text-align: center;
  margin: 0 auto;
  width: 43%;
}
section.ecosystem img {
  margin: 0 auto;
  display: block;
  max-width: 62%;
}

section.tone .background-banner {
  background-position: right;
  background-size: 80%;
  background-repeat: no-repeat;
}
section.tonecloud .background-banner {
  background-position: right;
  background-size: 50%;
  background-repeat: no-repeat;
}
section.tonecloud {
  background-image: linear-gradient(to right, #11100b, #1e150d);
}
section.tonecloud > div {
  background-image: url(../assets/bias-fx-mobile/6-tone-cloud-no-background-2@2x.png);
}
section.effect {
  background-color: #161519;
}

section.effect > div {
  background-image: url(../assets/bias-fx-mobile/5-stunning-effects-2@2x.png);
  background-position: left;
  background-size: 80%;
  background-repeat: no-repeat;
}
section.tone > div {
  background-image: url(../assets/bias-fx-mobile/4-amp-3-d-render@2x.png);
  background-position: center;
}
/* section.ecosystem > div { */
/*   background-image: url(../assets/bias-fx-mobile/3-ecosystem-2@2x.png); */
/* } */
section.processor > div {
  background-image: url(../assets/bias-fx-mobile/2-world-class-guitar-processor-2@2x.png);
  background-position: center bottom;
}

.background-banner img {
  max-height: 680px;
  max-width: 47%;
  object-fit: cover;
}

.hero {
  position: relative;

  .subtitle {
    font-weight: 600;
    color: white;
  }

  .mobile-en {
    color: #7df0ee;

    a {
      color: #7df0ee;
    }
  }
}
.hero > div.image {
  background-image: url(../assets/bias-fx-mobile/1-hero-2@2x.png);
  min-height: 785px;
  background-size: cover;
  width: 100%;
}

.hero .image {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.hero .image .app-download {
  background-image: url(../assets/app-store.svg);
  width: 169px;
  height: 62px;
  background-size: cover;
  position: absolute;
  bottom: 5%;
}

section.feature {
  margin: 0 auto;
  overflow: hidden;
  padding: 100px 15%;
}

.feature-card {
  width: 48%;
  float: left;
}

.feature-card:nth-child(even) {
  margin-left: 4%;
}

.feature-card p {
  font-size: 28px;
  font-weight: 300;
  color: white;
}

#feature-card-1 {
  border-top: 2px solid #ff7d27;
}
#feature-card-2 {
  border-top: 2px solid #30ffc5;
}
#feature-card-3 {
  border-top: 2px solid #f72361;
}
#feature-card-4 {
  border-top: 2px solid #812df2;
}

section.important-feature {
  background-color: #08090a;
  margin: 100px 0;
}
section.important-feature h3 {
  margin: 0;
  margin-bottom: 1rem;
}
section.important-feature ul {
  margin: 0;
  /* padding-left: 20px; */
}
section.important-feature div {
  width: 61%;
  margin: 0 auto;
}
section.important-feature div > ul {
  color: #c3c3c3;
  display: inline-block;
  width: calc(50% - 80px);
  vertical-align: top;
  line-height: 1.93;
}
h1 span {
  font-weight: 300;
}

.footer-link {
  display: flex;
  justify-content: center;
  margin-bottom: 100px;
}
.footer-link > div {
  display: inline-block;
}
.footer-link > div:nth-of-type(2) {
  margin-left: 21px;
}
.footer-link img {
  width: 76px;
  height: 76px;
}
.footer-link h3 {
  font-size: 30px;
  font-weight: 900;
  font-family: Roboto;
}
.footer-link h3,
.footer-link p {
  color: white;
  margin-top: 0;
  margin-bottom: 0;
}

.footer-link span {
  font-weight: 300;
}
.footer-link a {
  background-image: url(../assets/app-store.svg);
  width: 169px;
  height: 62px;
  background-size: cover;
}
.hero-mobile {
  display: none;
}
.intro-video {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 85px;
}
.intro-video > div {
  width: 100% !important;
}

section.video > div {
  display: flex;
  width: 80%;
  margin: 0 auto;
  flex-flow: row wrap;
}

@media screen and (min-width: 1024px) {
  section.video > div > div:last-of-type {
    flex-basis: calc(33% - 60px);
  }
}

@media screen and (max-width: 768px) {
  .hero-desktop {
    display: none;
  }
  .hero-mobile {
    display: block;
  }
  .hero-mobile .image {
    display: flex;
    min-height: 400px !important;
    margin-bottom: 20px;
  }
  .hero-mobile h1 {
    font-size: 40px;
  }
  .hero-mobile h1,
  .hero-mobile p {
    text-align: center;
    width: 78%;
    margin: 0 auto;
  }
  section.feature {
    padding: 50px 6%;
  }
  .feature-card {
    width: 100%;
  }
  .feature-card:nth-child(even) {
    margin-left: 0;
  }
  .feature-card p {
    font-size: 20px;
  }
  .background-banner p {
    font-size: 10px;
  }
  .background-banner {
    justify-content: flex-start;
    align-items: flex-start;
  }
  .background-banner .text {
    text-align: center;
    padding-left: 2.5%;
    padding-right: 2.5%;
  }
  .effect .background-banner .text {
    /* padding-bottom: 1000px; */
  }
  .tonecloud .background-banner {
    min-height: 750px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom;
  }
  .effect .background-banner {
    background-color: #161519;
    max-height: 750px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center bottom;
  }
  .ecosystem {
    min-height: 750px;
  }
  section.ecosystem div {
    position: relative;
    height: 750px;
  }
  section.ecosystem div > div {
    width: 95%;
  }
  section.ecosystem img {
    position: absolute;
    bottom: 0;
    margin: 0;
    display: block;
    max-width: 100%;
  }
  section.important-feature {
    text-align: center;
    display: block;
  }
  section.important-feature ul {
    text-align: left;
    width: 80% !important;
    margin: 0;
  }
  section.important-feature div {
    width: 100%;
    margin: 0 auto;
  }
  section.important-feature div > ul {
    color: #c3c3c3;
    display: inline-block;
    width: calc(50% - 80px);
    vertical-align: top;
    line-height: 1.93;
  }
  section.tonecloud > div {
    background-image: linear-gradient(
        to top,
        rgba(255, 0, 0, 0),
        #1e150d,
        rgb(17, 16, 11)
      ),
      url(../assets/bias-fx-mobile/6-tone-cloud-no-background-2@2x.png);
    /* background-image: linear-gradient(to bottom, #11100b, #1e150d), url(../assets/bias-fx-mobile/6-tone-cloud-no-background-2@2x.png); */
  }
  section.tone .background-banner {
    background-position: right bottom;
    background-size: 150%;
    min-height: 750px;
  }
  section.tonecloud .background-banner {
    background-position: center;
    background-size: cover;
  }
  section.effect .background-banner {
    background-size: bottom;
    background-repeat: no-repeat;
    min-height: 105vh;
    background-image: url(../assets/bias-fx-mobile/5-stunning-effects-2-copy@2x.png);
  }
  .background-banner p {
    font-size: 16px;
  }
}
@media screen and (max-width: 551px) {
  section.tone .background-banner {
    min-height: 550px;
  }
}
@media only screen and (max-device-width: 768px) and (orientation: landscape) {
  section.effect .background-banner {
    min-height: 250vh;
  }
  section.tone .background-banner {
    min-height: 680px;
  }
  section.tonecloud .background-banner {
    min-height: 500px;
  }
}
@media only screen and (max-device-width: 768px) and (orientation: landscape) and (min-resolution: 192dpi) {
  .background-banner p {
    font-size: 10px;
    line-height: 1.2;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bias-fx-mobile.vue